// extracted by mini-css-extract-plugin
export default {"container":"vertical_container__9Trat","main":"vertical_main__CiYyl","box":"vertical_box__j1BYe","title":"vertical_title__rKNeS","video":"vertical_video__QZHvv"};